export const ROLE_IDS = {
  admin: 'admin',
  manager: 'manager',
  agent: 'agent',
} as const;

export type RoleId = (typeof ROLE_IDS)[keyof typeof ROLE_IDS];

interface IRole {
  id: RoleId;
  name: string;
  login_methods: string[];
}

export interface IOrganization {
  id: string;
  name: string;
  internal_code: string;
  active: boolean;
  logo_url: string | null;
  roles: IRole[];
}

export interface IUserOrgsData {
  organizations: IOrganization[];
  user: {
    email: string;
  };
}

export interface IOrgSwitcherState {
  loading: boolean;
  error: string | null;
  data: IUserOrgsData | null;
}
